
import { defineComponent, onMounted, onUnmounted } from 'vue'

import LayoutHandler from './layouts/LayoutHandler.vue'

import { useAuthStore } from './store/auth'

export default defineComponent({
  name: 'App',
  components: { LayoutHandler },
  setup() {
    const authStore = useAuthStore()
    let intervalId: ReturnType<typeof setInterval>

    onMounted(() => {
      console.info('User access scopes: ', authStore.scopes)

      if (authStore.isAuthenticated) {
        authStore.fetchMe()
      }

      intervalId = setInterval(() => {
        if (authStore.isAuthenticated) {
          authStore.fetchMe()
        }
      }, 60000) // Fetch updated role/scopes every 60 seconds
    })

    onUnmounted(() => {
      if (intervalId) clearInterval(intervalId)
    })
  },
})
